// pages/404.js
export default function Custom404() {
  return <h1>This video is being processed.</h1>;
}
